import Box from "@memorang/ui/components/Box";
import InfoAlert from "@memorang/ui/components/InfoAlert";
import TooltipWrapper from "@memorang/ui/components/TooltipWrapper";
import { useDevice } from "@memorang/ui/useDevice";
import { getSessionSummary } from "./helpers";

type SessionSummaryProps = {
	numRequiredItems: number;
	selectedDistributionCheckboxMap?: Record<string, boolean>;
	selectedTagCheckboxMap?: Record<string, boolean>;
	sectionTags?: { title: string; tags: { id: number; title: string }[] }[];
	timeEstimate?: string;
	modeLabel?: string;
};

const SessionSummary = ({
	numRequiredItems,
	selectedDistributionCheckboxMap,
	selectedTagCheckboxMap,
	sectionTags,
	timeEstimate,
	modeLabel = "items",
}: SessionSummaryProps) => {
	const selectedProgresses = selectedDistributionCheckboxMap
		? Object.keys(selectedDistributionCheckboxMap)
				.filter((key) => selectedDistributionCheckboxMap[key])
				.sort()
		: [];

	const { isMobile } = useDevice();

	const allTags = sectionTags?.flatMap((section) => section.tags) || [];
	const totalAvailableTopics = allTags.length;

	const selectedTopics = selectedTagCheckboxMap
		? Object.keys(selectedTagCheckboxMap)
				.filter((tagId) => selectedTagCheckboxMap[tagId])
				.map((tagId) => {
					const tag = allTags.find((t) => t.id === Number(tagId));
					return tag?.title;
				})
				.filter((title): title is string => Boolean(title))
		: [];

	const summaryText = getSessionSummary({
		progresses: selectedProgresses,
		itemCount: numRequiredItems,
		modeLabel,
		selectedTopics,
		totalTopicCount: totalAvailableTopics,
		timeEstimate,
	});

	const hasSelectedTopics = selectedTopics.length > 0;
	const tooltipText = hasSelectedTopics ? selectedTopics.join(", ") : undefined;

	return (
		<Box
			paddingHorizontal={isMobile ? 16 : 24}
			paddingTop={8}
			marginBottom={-8}
		>
			{hasSelectedTopics && selectedTopics.length > 2 ? (
				<TooltipWrapper title={tooltipText!}>
					<InfoAlert
						text={summaryText}
						icon="information-outline"
						padding={8}
					/>
				</TooltipWrapper>
			) : (
				<InfoAlert text={summaryText} icon="information-outline" padding={8} />
			)}
		</Box>
	);
};

export default SessionSummary;
